export default {
  title: "Anlama ve Zevk Alma",
  text: `Anlamak zevk verir, ilgi uyandırır, güven duygusu aşılar. Bu güzel duygular, öğrenciyi daha fazla okumaya yöneltir. Onun istek ve azmini artırır ve onu, tadını aldığı iş için bir çalışma programı yapmaya teşvik eder. Bu nokta ya gelmiş öğrenci, derece derece daha ileri, ama hep biraz çabayla anlayabileceği kitaplar seçmelidir. 

  Dikkati çekmekte fayda var: Dersten soğuma ve okumaktan uzaklaşmanın nedeni, anlama ümidini kaybetme ve kendi kapasitesinden şüpheye düşmedir. İnsan yeniden küskünlük ve karamsarlık doğuracak nahoş bir işe doğal olarak el atmak istemez. Bu nedenle, zihinde var olan bilgilerle bağlantı kurmaya imkan veren uygun güçlük derecesinde bir içerikle işe başlamak ve anlamanın zevkini tatmak kritik önem taşır.
  
  Öğrenmeyle zihindeki bilgiler derece derece arttıkça, o konuyla ilgili, daha yüksek düzeyde içeriklerle devam etmek gerekir. Böylece her öğrenme basamağında, bilinmeyenleri, önceki bilgilerle yorumlamak mümkün olacaktır. 
  `
};



// WEBPACK FOOTER //
// ./src/assets/goz-ritim/ilkokul/13.js